import { SITE } from "@/config/site";
import { StarOrnament } from "@/components/Ornament";

export function Marquee() {
  const items = [...SITE.marquee, SITE.urdu];
  const tripled = [...items, ...items, ...items];
  return (
    <section
      className="relative overflow-hidden border-y border-[#D4AF37]/15 bg-[#0A0805] py-6"
      aria-hidden="true"
    >
      <div className="marquee-track flex w-max items-center">
        {tripled.map((text, i) => {
          const isUrdu = text === SITE.urdu;
          return (
            <span key={i} className="flex items-center">
              <span
                dir={isUrdu ? "rtl" : "ltr"}
                className={
                  isUrdu
                    ? "font-urdu px-8 text-3xl text-[#D4AF37]/70 sm:text-4xl"
                    : "font-display text-outline-gold px-8 text-3xl uppercase tracking-[0.18em] sm:text-4xl"
                }
              >
                {text}
              </span>
              <StarOrnament className="h-4 w-4 shrink-0 text-[#D4AF37]/60" />
            </span>
          );
        })}
      </div>
    </section>
  );
}
